import { useState, useEffect } from "react";
import {
  menuAbout,
  specialClinic,
  menuNew,
  menuContact,
  menuSurgery,
  menuDiagnose,
  menuOther,
} from "../inc/Datamenu_inc";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import { motion, AnimatePresence } from "framer-motion";

export default function Sidebar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openMenu, setOpenMenu] = useState(null); // State สำหรับเมนูที่กำลังคลิก
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const navigate = useNavigate();
  // ฟังก์ชันปิด Sidebar เมื่อคลิกนอกพื้นที่ Sidebar
  const closeSidebar = (e) => {
    if (e.target.id === "backdrop") {
      setIsMenuOpen(false);
      setOpenMenu(null); // รีเซ็ตเมนูเมื่อปิด Sidebar
    }
  };

  const handleClickEnter = (menuName) => {
    setOpenMenu(menuName);
  };

  const closeSubMenu = () => {
    setOpenMenu(null); // ปิด Sidebar 2 และกลับไป Sidebar 1
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100); // เปลี่ยนเลขนี้ตามจุดที่ต้องการให้ Navbar ติดบนสุด
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const backdropVariants = {
  //   hidden: { opacity: 0 },
  //   visible: { opacity: 1 },
  // };

  // const sidebarVariants = {
  //   hidden: { x: "-100%" },
  //   visible: {
  //     x: 0,
  //     transition: { type: "spring", stiffness: 300, damping: 30 },
  //   },
  // };

  // const menuItemVariants = {
  //   hover: {
  //     backgroundColor: "rgba(91, 173, 210, 0.3)",
  //     x: 5,
  //   },
  //   tap: { scale: 0.98 },
  // };

  const socialIconVariants = {
    hover: {
      scale: 1.1,
      y: -3,
      transition: { type: "spring", stiffness: 400, damping: 10 },
    },
  };

  return (
    <>
      <Modal
        id="default-modal"
        title={"Line official NOVEL CMU"}
        size="max-w-sm"
        linkDownload={""}
        show={showModal}
        onClose={closeModal}
      >
        <div className="flex flex-col justify-center items-center gap-y-5">
          <img
            src="https://qr-official.line.me/gs/M_081ctdmi_BW.png?oat_content=qr"
            alt="Line ID"
          />
          <button
            onClick={() => window.open("https://lin.ee/zFKvapU", "_blank")}
            className="bg-green-500 hover:bg-green-600 w-full transition-all duration-500 ease-linear text-white py-2 px-4 rounded "
          >
            Add Line Official NOVEL CMU
          </button>
        </div>
      </Modal>
      {/* Mobile Header */}
      <motion.div
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={`lg:hidden block ${
          isScrolled ? "fixed shadow-md" : ""
        } min-w-screen mx-auto bg-[#5BADD2] p-5 text-3xl top-0 w-full z-50 flex justify-between items-center`}
      >
        <motion.span
          whileTap={{ scale: 0.9 }}
          onClick={() => setIsMenuOpen(true)}
          className="text-gray-100 cursor-pointer"
        >
          <i className="fa fa-bars"></i>
        </motion.span>

        <motion.div
          className="flex justify-center items-center gap-x-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <motion.div
            variants={socialIconVariants}
            whileHover="hover"
            whileTap="tap"
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=61558866538285",
                "_blank"
              )
            }
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer shadow-md"
          >
            <i className="fab fa-facebook-f text-[#5BADD2] text-xl"></i>
          </motion.div>

          <motion.div
            variants={socialIconVariants}
            whileHover="hover"
            whileTap="tap"
            onClick={() => setShowModal(true)}
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer shadow-md"
          >
            <i className="fab fa-line text-[#5BADD2] text-xl"></i>
          </motion.div>
        </motion.div>
      </motion.div>

      <div
        id="backdrop"
        onClick={closeSidebar}
        className={`bg-black/50 fixed top-0 left-0 w-full h-full z-40 transition-opacity duration-300 ${
          isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        {/* Sidebar */}
        <div
          className={`w-[320px] h-full  bg-gray-900 text-white transform transition-transform duration-300 ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          } ${openMenu ? "hidden" : "block"}`}
        >
          <div className="flex justify-between items-center px-2 py-2">
            <h2>Menu</h2>
            <button
              onClick={() => setIsMenuOpen(false)} // ปิด Sidebar
              className="text-white text-2xl "
            >
              &times;
            </button>
          </div>
          <div className="border-b"></div>

          <div
            onClick={() => navigate("/")}
            className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2]"
          >
            <span className="ps-4  cursor-pointer text-sm ">หน้าหลัก</span>
          </div>

          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">
                เกี่ยวกับเรา
              </span>
            </div>
            <div
              onClick={() => handleClickEnter("เกี่ยวกับเรา")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>
          <div
            onClick={() => navigate(`/other/page/${menuOther[3].id}`)}
            className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2]"
          >
            <span className="ps-4  cursor-pointer text-sm ">
              อายุรกรรมทั่วไป
            </span>
          </div>
          <div
            onClick={() => navigate(`/other/page/${menuOther[2].id}`)}
            className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2]"
          >
            <span className="ps-4  cursor-pointer text-sm ">หน่วยฉุกเฉิน</span>
          </div>
          <div
            onClick={() => navigate(`/other/page/${menuOther[1].id}`)}
            className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2]"
          >
            <span className="ps-4  cursor-pointer text-sm ">
              หออภิบาลสัตว์ป่วย
            </span>
          </div>
          <div
            onClick={() => navigate(`/other/page/${menuOther[0].id}`)}
            className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2]"
          >
            <span className="ps-4  cursor-pointer text-sm ">
              ห้องปฏิบัติการโลหิตวิทยา
            </span>
          </div>

          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">คลินิกพิเศษ</span>
            </div>
            <div
              onClick={() => handleClickEnter("คลินิกพิเศษ")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>

          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">ศัลยกรรม</span>
            </div>
            <div
              onClick={() => handleClickEnter("ศัลยกรรม")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>
          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">
                หน่วยทัศนวินิจฉัย
              </span>
            </div>
            <div
              onClick={() => handleClickEnter("หน่วยทัศนวินิจฉัย")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>

          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">ข่าวประกาศ</span>
            </div>
            <div
              onClick={() => handleClickEnter("ข่าวประกาศ")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>

          <div className="flex justify-between item-center">
            <div className="border-b border-gray-800 py-2 cursor-pointer hover:bg-[#5bAdd2] w-full">
              <span className="ps-4  cursor-pointer text-sm ">ติดต่อเรา</span>
            </div>
            <div
              onClick={() => handleClickEnter("ติดต่อเรา")}
              className="flex items-center border border-gray-800 px-3 text-gray-300 cursor-pointer"
            >
              <i className="fa fa-arrow-alt-circle-right"></i>
            </div>
          </div>
        </div>

        <div
          className={`w-[320px] h-full  bg-gray-800 text-white transform transition-transform duration-300 ${
            openMenu ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center px-2 py-2">
            <button
              onClick={() => closeSubMenu()} // ปิด Sidebar
              className="text-white text-2xl "
            >
              <i className="text-gray-400 fa fa-arrow-alt-circle-left"></i>
            </button>
            <h2>{openMenu}</h2>
          </div>
          <div className="border-b"></div>
          {openMenu === "เกี่ยวกับเรา" && (
            <>
              {menuAbout.map((item) => (
                <div
                  onClick={() => navigate(item.link)}
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}

          {openMenu === "คลินิกพิเศษ" && (
            <>
              {specialClinic.map((item) => (
                <div
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                  onClick={() => {
                    navigate(`/clinic/page/${item.id}`);
                  }}
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}

          {openMenu === "ศัลยกรรม" && (
            <>
              {menuSurgery.map((item) => (
                <div
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                  onClick={() => {
                    navigate(`/surgery/page/${item.id}`);
                  }}
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}

          {openMenu === "หน่วยทัศนวินิจฉัย" && (
            <>
              {menuDiagnose.map((item) => (
                <div
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                  onClick={() => {
                    navigate(`/center/page/${item.id}`);
                  }}
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}

          {openMenu === "ข่าวประกาศ" && (
            <>
              {menuNew.map((item) => (
                <div
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                  onClick={() => navigate(`/news/page/${item.id}`)}
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}

          {openMenu === "ติดต่อเรา" && (
            <>
              {menuContact.map((item) => (
                <div
                  key={item.id}
                  className={`border-b border-gray-700 py-2 cursor-pointer hover:bg-[#5bAdd2] ${
                    item.status ? "" : "hidden"
                  }`}
                  onClick={() =>
                    item.link.startsWith("https://")
                      ? window.open(item.link, "_blank")
                      : navigate(item.link)
                  }
                >
                  <span
                    className={`${
                      item.status ? "" : "hidden"
                    }ps-4  cursor-pointer text-sm`}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
}
